// extracted by mini-css-extract-plugin
module.exports = {"not_added_img":"not_added_img___ibCQx","not_added_tip":"not_added_tip___n6yxy"};